import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import App from './App';
import { initOnlineSync } from './utils/syncService';
import { I18nProvider } from './i18n/i18n';

// 初始化在线同步监听器（应用启动时触发一次处理）
initOnlineSync();

import { App as AntdApp } from 'antd';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <I18nProvider>
      <ConfigProvider theme={{ token: { colorPrimary: '#1890FF' } }}>
        <AntdApp>
          <App />
        </AntdApp>
      </ConfigProvider>
    </I18nProvider>
  </React.StrictMode>
);
